import { Link } from 'react-router-dom';
import { } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-100 mt-auto" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src="/logo.png" alt="HabeshaTown" className="h-9 w-9 object-contain" />
              <span className="font-bold text-xl text-gray-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Habesha<span className="text-primary">Town</span>
              </span>
            </Link>
            <p className="text-sm text-gray-500 mb-3">
              A marketplace for the Habesha community.
            </p>
          </div>

          {/* Browse */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Browse
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/browse?category=electronics" className="text-gray-500 hover:text-primary transition-colors">
                  Electronics
                </Link>
              </li>
              <li>
                <Link to="/browse?category=vehicles" className="text-gray-500 hover:text-primary transition-colors">
                  Vehicles
                </Link>
              </li>
              <li>
                <Link to="/browse?category=housing" className="text-gray-500 hover:text-primary transition-colors">
                  Housing
                </Link>
              </li>
              <li>
                <Link to="/browse?category=jobs" className="text-gray-500 hover:text-primary transition-colors">
                  Jobs
                </Link>
              </li>
              <li>
                <Link to="/browse" className="text-gray-500 hover:text-primary transition-colors">
                  All Categories
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Company
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/about" className="text-gray-500 hover:text-primary transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-gray-500 hover:text-primary transition-colors">
                  Help & Support
                </Link>
              </li>
              <li>
                <Link to="/jobs" className="text-gray-500 hover:text-primary transition-colors">
                  Jobs Community
                </Link>
              </li>
              <li>
                <Link to="/community-rules" className="text-gray-500 hover:text-primary transition-colors">
                  Community Rules
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Legal
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/privacy" className="text-gray-500 hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-500 hover:text-primary transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-100">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              &copy; {currentYear} HabeshaTown. All rights reserved.
            </p>
            <p className="text-xs text-gray-400">
              Connecting the Habesha community worldwide.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
